import React from "react";

import CheckIcon from "@mui/icons-material/Check";
import { MenuItemProps, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { lightOrDark } from "@app/embedded/theme/utils";

import { DefaultBadge } from "@rui/Badge";
import MenuItem from "@rui/Dropdown/MenuItem";
import { Row } from "@rui/Stack";

interface DropdownMenuItemProps extends MenuItemProps {
  label?: React.ReactNode;
  selected?: boolean;
  isDefault?: boolean;
  renderDefaultLabel?: () => React.ReactNode;
  startIcon?: React.ReactNode;
}

const StyledMenuItem = styled(MenuItem)({
  marginTop: "2px",
  marginBottom: "2px",
  minHeight: "auto",
});

const DropdownMenuItem = ({
  label,
  selected = false,
  isDefault,
  value,
  renderDefaultLabel,
  startIcon = null,
  ...props
}: DropdownMenuItemProps) => {
  return (
    <StyledMenuItem value={value} {...props}>
      <Row variant="apart" sx={{ width: "100%" }}>
        <Row variant="left" spacing={1} flexGrow={1}>
          {startIcon}
          {typeof label === "string" ? (
            <Typography
              variant="bodySecondaryReg"
              sx={{
                color: (theme) =>
                  selected
                    ? lightOrDark(
                        "shades.neutral.800",
                        "shades.neutral.50"
                      )(theme)
                    : lightOrDark(
                        "shades.neutral.600",
                        "shades.neutral.200"
                      )(theme),
                fontStyle: value === "" ? "italic" : "none",
              }}
            >
              {value === "" ? "None" : label ?? value}
            </Typography>
          ) : (
            label
          )}
          {isDefault &&
            (renderDefaultLabel ? renderDefaultLabel() : <DefaultBadge />)}
        </Row>
        {selected && (
          <CheckIcon
            sx={{
              height: "18px",
              width: "18px",
              color: (theme) =>
                lightOrDark("shades.primary.500", "shades.primary.400")(theme),
              marginLeft: 1,
            }}
          />
        )}
      </Row>
    </StyledMenuItem>
  );
};

export default DropdownMenuItem;
